





























import MeasureTool from  '../../../../plugins/MeasureTool-GoogleMaps-V3/src/index';
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import { Loader, LoaderOptions } from '@googlemaps/js-api-loader';

import MapProvider from './MapProvider.vue';
import { RootStoreHelper } from '../../mixins';
@Component({
    components: { MapProvider }
})
export default class MapLoader extends Mixins(RootStoreHelper) {
    google: any = null;
    map: google.maps.Map | null = null;
    @Prop()
    mapConfig: google.maps.MapOptions;
    @Prop()
    customClass: String;
    @Prop()
    apiKey: string;
    activeBtn: number = 1;
    showNav: boolean = true;
    measureTool: any = null;

    @Prop({ default: false }) showLabel: boolean;
    created() {
        let self = this;
        
        const loader = new Loader({
            apiKey: this.apiKey,
            libraries: ["drawing"]
        });
        loader
        .importLibrary('maps')
        .then((google) => {
            //  console.log('google maps initialized correctly', google);
            this.google = google;
            this.initializeMap();
        })
        .catch((e) => {
            //  console.error('google maps initialization error', e);
        });
    }

  

    async initializeMap() {
        const mapContainer = this.$el.querySelector('#map');
        await google.maps.importLibrary("marker");
        const { Map } = this.google;

        let self = this;
        this.map = new Map(mapContainer, {
            ...self.mapConfig,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            controlSize: 25
        });
        if (this.map) {
            this.map.getStreetView().setOptions({
                addressControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT
                }
            });
            this.measureTool = new MeasureTool(this.map, 
                {
                    showSegmentLength: true,
                    tooltip: true,
                    unit: 'metric' // metric, imperial, or nautical
                }
            );

            this.measureTool.addListener('measure_start', (e) => {
                this.onMeasureStart();
            });
            this.measureTool.addListener('measure_end', (e) => {
                this.onMeasureEnd();
            });
        }
    }

    @Emit()
    onMeasureStart(){
        
    }
    @Emit()
    onMeasureEnd(){}

    get mapObject(): any {
        return this.map;
    }

    get googleObject(): any {
        return this.google;
    }
}
